module.exports = __webpack_public_path__ + "img/chinesecompany199.8c2876c0.png";